import { JSX } from "preact";
import classNames from "classnames";

/**
 *
 * This component provides a structured layout for showcasing benefits, features, or advantages
 * with icons, titles, and descriptions. It's designed to be flexible and reusable.
 *
 * Example usage (new simplified format with image):
 * ```mdx
 *   <BenefitItem>
 *     <img src="/img/icons/tailored-solutions.svg" alt="Tailored Solutions" />
 *
 *     ### Tailored Solutions
 *
 *     We take the time to understand your industry's specific challenges and goals,
 *     delivering solutions that fit like a glove.
 *   </BenefitItem>
 * ```
 *
 * Example usage (with emoji):
 * ```mdx
 *   <BenefitItem>
 *     <BenefitIcon>💡</BenefitIcon>
 *
 *     ### Tailored Solutions
 *
 *     We take the time to understand your industry's specific challenges and goals,
 *     delivering solutions that fit like a glove.
 *   </BenefitItem>
 * ```
 */

export function BenefitItem(props: { children: JSX.Element | JSX.Element[]; accent?: boolean }) {
  return (
    <div class={classNames("benefit-item", props.accent && "accent")}>
      {props.children}
    </div>
  );
}

export function BenefitIcon(props: { children?: JSX.Element | string }) {
  return (
    <div class="benefit-icon">
      {props.children}
    </div>
  );
}